import React from 'react';
import Paths from '@root/utils/Path';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { adminUserName } from '@api/graphql/types';

interface Props {
    userId: string;
}

interface State {
    name: string | null;
}

class AdminUserLink extends React.Component<Props, State> {
    public state: State = {
        name: null,
    };

    public componentDidMount() {
        const variables = {
            page: 1,
            count: 1,
            filters: {id: this.props.userId},
        };

        GraphQLClient.query<adminUserName>({
            query: Queries.adminUserName,
            variables,
        }).then((response) => {
            if (response.data && response.data.listUsers) {
                const currentUser = response.data.listUsers.data[0];
                this.setState({ name: currentUser.name });
            }
        });
    }

    public render() {
        return <a href={`${Paths.adminUser}/${this.props.userId}`}>{this.state.name ? this.state.name : 'Betöltés...'}</a>;
    }
}

export default AdminUserLink;



// WEBPACK FOOTER //
// ./src/components/AdminUserLink.tsx